import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerStatus, CustomerStatusLabels, RiyadCustomerStatus, RiyadCustomerStatusLabels } from '@lib/enums/customer.enum';
import { AngularMaterialModule } from '../../../material.module';
import { Utils } from '@lib/utils/utils';
import { Permission } from '@lib/enums/permissions.enum';
import { TenantService } from '@lib/services/tenant.service';
import { customerTenant } from '@env/environment';

interface StatusEnum {
    [key: string]: CustomerStatus | RiyadCustomerStatus;
}

interface StatusLabelsEnum {
    [key: string]: CustomerStatusLabels | RiyadCustomerStatusLabels;
}

@Component({
    selector: 'app-status',
    standalone: true,
    imports: [CommonModule, AngularMaterialModule],
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
})
export class StatusComponent {
    protected currentTenant: string;
    protected isRiyadTenant: boolean;

    constructor(private utils: Utils, private tenantService: TenantService) {
        this.currentTenant = this.tenantService.getTenantKey() || '';
        this.isRiyadTenant = this.currentTenant.split('_')[0] === customerTenant.RIYAD;
        if(this.isRiyadTenant) {
            this.statusEnum = RiyadCustomerStatus;
            this.statusEnumLabels = RiyadCustomerStatusLabels;
        }
    }

    @Input() status?: string = '';
    @Input() svgIcon?: string = '';
    @Input() isDropdown?: boolean = false;
    @Input() isCenterText?: boolean = false;
    @Input() placeholder = '';
    @Input() disabled = false;
    statusEnum: StatusEnum = CustomerStatus;
    statusEnumLabels: StatusLabelsEnum = CustomerStatusLabels;
    hasPermission = this.utils.getPermissions(Permission.CustomerChangeStatus);
}
